import {Box, forwardRef} from '@chakra-ui/react';
import {HeaderWrapper} from 'components/layouts';
import {useRouter} from 'next/router';
import {ReactElement} from 'react';
import {IRestaurantResponse, ProviderTypeEnum} from 'types';

import {IMetroCategory} from '../../metro/types';
import {HeaderDesktop} from './components/header-desktop';
import {HeaderMobile} from './components/header-mobile';

interface IProps {
  providerType?: ProviderTypeEnum;
  providerName?: string;
  isDesktop: boolean;
  children?: ReactElement;
  isMetro?: boolean;
  provider?: IRestaurantResponse;
  categories?: IMetroCategory[];
}

export const Header = forwardRef((props: IProps, ref) => {
  const {children, providerType, providerName, isDesktop, isMetro, provider, categories} = props;

  const {pathname} = useRouter();
  const shouldHideSearch = ['/profile', '/cards'].includes(pathname);

  return (
    <Box
      w="100%"
      bg="white"
      position="fixed"
      alignItems="center"
      top={0}
      zIndex="overlay"
      ref={ref}
      id="headerContainer"
    >
      <HeaderWrapper
        as="header"
        id="header"
        h={[!shouldHideSearch ? '120px' : '60px', '80px']}
        alignItems="center"
        boxShadow="header"
        innerbox={{
          h: 'full',
        }}
        isMetro={isMetro}
      >
        {isDesktop ? (
          <HeaderDesktop
            isDesktop={isDesktop}
            shouldHideSearch={shouldHideSearch}
            providerType={providerType}
            providerName={providerName}
            isMetro={isMetro}
            provider={provider}
          />
        ) : (
          <HeaderMobile
            isDesktop={isDesktop}
            shouldHideSearch={shouldHideSearch}
            providerType={providerType}
            providerName={providerName}
            provider={provider}
            isMetro={isMetro}
            categories={categories}
          />
        )}
      </HeaderWrapper>
      {!!children && <div id="subheader">{children}</div>}
    </Box>
  );
});
